/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createHook } from '../../core/factories/createHook.js';

import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetPartnerCreatorRow } from '../openapi-types.gen.js';
import { type useGetPartnerCreatorArgs, useGetPartnerCreatorSpec } from '../specs/admin.spec.gen.js';

export type { GetPartnerCreatorRow } from '../openapi-types.gen.js';
export type { useGetPartnerCreatorArgs } from '../specs/admin.spec.gen.js';


/**
 * Available query params (forwarded automatically; pass via the
 * hook's args): id.
 */
const _useGetPartnerCreator = createHook(useGetPartnerCreatorSpec);
export const useGetPartnerCreator = _useGetPartnerCreator as (args: useGetPartnerCreatorArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetPartnerCreator>;


/**
 * Hover/intent prefetch companion for `useGetPartnerCreator`. Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * and writes the response into the SAME cache entry the reader hook
 * observes. The component owning the callback does NOT subscribe — no
 * re-renders on data, no NATS subscription. Idempotent: TanStack
 * `prefetchQuery` is a no-op when a fresh cache entry already exists.
 *
 *     function Link({ pubkey }) {
 *       const prefetch = usePrefetchGetPartnerCreator();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({ pubkey })}
 *           onFocus={() => prefetch({ pubkey })}
 *         >…</a>
 *       );
 *     }
 */
export const usePrefetchGetPartnerCreator = createPrefetchHook(useGetPartnerCreatorSpec) as () => import('../../types/SdkPrefetchTask.js').SdkPrefetcher<useGetPartnerCreatorArgs>;
